// src/components/CarFooter.jsx
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/variables.css";
import axios from "axios";

import Logo from "../img/Logo.png";
import BtnAppStore from "../img/AppStorePrezzOk.svg";
import BtnGPlayStore from "../img/GPlayPrezzOk.svg";

import Cookie from '../components/Modal/Cookie';

const CarFooter = () => {
  const [footerData, setFooterData] = useState(null);
  const [os, setOs] = useState("other");
  const [showCookie, setShowCookie] = useState(false);

  // 1) fetch dati footer
  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const { data } = await axios.get(
          `https://gestione.carellidistribuzione.it/react-endpoint-api/get-data-page/footer?${Date.now()}`
        );
        const root = data.footer ?? data.data?.footer;
        setFooterData(Object.values(root)[0]);
      } catch (err) {
        console.error("Errore caricamento footer:", err);
      }
    };
    fetchFooter();
  }, []);

  // 2) rilevo OS
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || "";
    if (/android/i.test(ua)) setOs("android");
    else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) setOs("ios");
    else setOs("other");
  }, []);


  // intercetta click su "/preferenze-cookie"
  const handleCookieClick = (e, url) => {
    if (url === "/preferenze-cookie") {
      e.preventDefault();
      setShowCookie(true);
    }
  };

  if (!footerData?.contenuti) return null;

  const sections = Object.values(footerData.contenuti);

  // 3) mapping link per app
  const prezzOkLinks = {
    ios: "https://apps.apple.com/it/app/prezzok/id1534146522",
    android:
      "https://play.google.com/store/apps/details?id=com.ifactory.prezzok&hl=it",
  };
  const primoPrezzoLinks = {
    ios:
      "https://apps.apple.com/it/app/primo-prezzo-la-spesa-lampo/id1574363708",
    android:
      "https://play.google.com/store/apps/details?id=com.ifactory.primoprezzo",
  };

  // helper per render link store
  const renderStoreLink = (linksObj, alt) => {
    if (os === "ios") {
      return (
        <a href={linksObj.ios} target="_blank" rel="noopener noreferrer">
          <img src={BtnAppStore} alt={`${alt} App Store`} />
        </a>
      );
    }
    if (os === "android") {
      return (
        <a href={linksObj.android} target="_blank" rel="noopener noreferrer">
          <img src={BtnGPlayStore} alt={`${alt} Google Play`} />
        </a>
      );
    }
    // fallback entrambi
    return (
      <>
        <a href={linksObj.ios} target="_blank" rel="noopener noreferrer">
          <img src={BtnAppStore} alt={`${alt} App Store`} />
        </a>
        <a href={linksObj.android} target="_blank" rel="noopener noreferrer">
          <img src={BtnGPlayStore} alt={`${alt} Google Play`} />
        </a>
      </>
    );
  };

  return (
    <footer className="position-relative"
      style={{
        padding: "32px 16px",
        gap: "16px",
        backgroundColor: "var(--mint)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}>
      <div className="position-absolute w-100 foot-onda">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 50"
          preserveAspectRatio="none"
          className="w-100"
        >
          <path
            fill="var(--mint)" // Colore di Bootstrap bg-light
            d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
          ></path>
        </svg>
      </div>
      <div className="container">
        <div className="row mt-3">
          {sections.map((sec) => {
            const items = sec.tema.Row ?? sec.tema.Column ?? [];
            const isRow = Boolean(sec.tema.Row);
            return (
              <div
                key={sec.ID}
                className="col-12 col-md-6 col-lg-3 mb-4"
              >
                <h4 className="--medium-1 bold">{sec.titolo_it}</h4>
                <ul
                  className={`list-unstyled mt-4 ${isRow ? "d-flex flex-row" : "d-flex flex-column"
                    }`}
                >
                  {items.map((it, i) => (
                    <li key={i} className={isRow ? "me-3" : "mb-2"}>
                      {(() => {
                        const isExternal = it.url.startsWith("http");
                       return (
                            <a
                                href={it.url}
                                target={isExternal ? "_blank" : undefined}
                                rel={isExternal ? "noopener noreferrer" : undefined}
                                className="text-decoration-none text-dark"
                                onClick={(e) => handleCookieClick(e, it.url)}
                              >
                                {it.icon ? (
                                  // Se c'è `it.icon` mostro solo l'icona
                                  <i className={it.icon} />
                                ) : (
                                  // Altrimenti mostro il testo, con iconaField se c'è
                                  <>
                                    {it.iconField && <span className={`${it.iconField} me-1`} />}
                                    {it.text}
                                  </>
                                )}
                              </a>
                            );
                      })()}
                    </li>

                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="row align-items-start">
          <div className="col-12 col-md-4 col-xl-6 d-none d-lg-block">
            <img
              src={Logo}
              alt="Logo"
              style={{ width: "200px", height: "auto" }}
            />
          </div>
          <div className="col-12 col-md-8 col-xl-6">
            <div className="row">
              {/* PrezzOk */}
              <div className="col-12 col-lg-6 mb-4">
                <div className="d-flex align-items-center mb-2">
                  <i className="icon-prezzoOk fs-2 me-2" />
                  <h4 className="medium-green mb-0">
                    Scarica l'app PrezzOk
                  </h4>
                </div>
                <div className="d-flex gap-2 mt-3">
                  {renderStoreLink(prezzOkLinks, "PrezzOk")}
                </div>
              </div>
              {/* Primo Prezzo */}
              <div className="col-12 col-lg-6 mb-4">
                <div className="d-flex align-items-center mb-2">
                  <i className="icon-primo-prezzo flex-shrink-0 fs-2 me-2 letter-spacing-1" />
                  <h4 className="medium-green mb-0">
                    Primo Prezzo – La Spesa Lampo
                  </h4>
                </div>
                <div className="d-flex gap-2 mt-3">
                  {renderStoreLink(primoPrezzoLinks, "Primo Prezzo")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Cookie
        show={showCookie}
        onHide={() => setShowCookie(false)}
      />
    </footer>
  );
};

export default CarFooter;
